import { render, staticRenderFns } from "./MindbodyVisits.vue?vue&type=template&id=f59d9586&"
import script from "./MindbodyVisits.vue?vue&type=script&lang=js&"
export * from "./MindbodyVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports